import type { AxiosInstance } from "axios";
import {
  doDeleteOrganizationIcon,
  doUploadOrganizationIcon,
  type U2104Organization,
} from "../../../U2104Service";
import type { U2104OrganizationIconPendingState } from "./u2104OrganizationIconPending";
import { hasOrganizationIconPendingChanges } from "./u2104OrganizationIconPending";

function extractOrganizationFromResponse(response: { data?: { result?: U2104Organization } & U2104Organization }) {
  return (response.data?.result ?? response.data) as U2104Organization | undefined;
}

/**
 * Applique upload/suppression icône en attente après save organisation réussi.
 * Le fichier remplace une suppression marquée (priorité upload).
 */
export async function flushPendingOrganizationIconChanges(
  axios: AxiosInstance,
  organizationId: string,
  pending: U2104OrganizationIconPendingState
): Promise<U2104Organization | null> {
  if (!hasOrganizationIconPendingChanges(pending)) {
    return null;
  }

  if (pending.pendingFile) {
    const formData = new FormData();
    formData.append("file", pending.pendingFile);
    const response = await doUploadOrganizationIcon(axios, organizationId, formData);
    return extractOrganizationFromResponse(response) ?? null;
  }

  if (pending.pendingDelete) {
    const response = await doDeleteOrganizationIcon(axios, organizationId);
    return extractOrganizationFromResponse(response) ?? null;
  }

  return null;
}
